'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/base-components/single-contact-link.js';
exports.SingleContactLink = SingleContactLink;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _themes = require('@marmalade/themes');
var _contactIcon = require('./contact-icon');
var _contactIcon2 = _interopRequireDefault(_contactIcon);
var _withHeaderTheme = require('../hocs/with-header-theme');
var _withHeaderTheme2 = _interopRequireDefault(_withHeaderTheme);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
var headerStyle = _themes.componentThemes.header.headerStyle;
SingleContactLink.propTypes = {
  theme: _propTypes.object.isRequired,
  width: _propTypes.number.isRequired,
  text: _propTypes.string.isRequired,
  icon: _propTypes.string.isRequired
};
function SingleContactLink(_ref) {
  var theme = _ref.theme,
    width = _ref.width,
    text = _ref.text,
    icon = _ref.icon,
    rest = _objectWithoutProperties(_ref, ['theme', 'width', 'text', 'icon']);
  return _react2.default.createElement(_glamorous2.default.A, Object.assign({}, rest, {
    color: theme[headerStyle('color')],
    lineHeight: '46px',
    fontSize: '1.8rem',
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19
    },
    __self: this
  }), _react2.default.createElement(_contactIcon2.default, {
    type: icon,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20
    },
    __self: this
  }), width >= theme.breakpoint_sm && _react2.default.createElement(_glamorous2.default.Span, {
    verticalAlign: 'middle',
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21
    },
    __self: this
  }, text));
}
exports.default = (0, _withHeaderTheme2.default)(SingleContactLink);